import SettingsIcon from "@mui/icons-material/Settings";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { SessionHandler } from "verdi-web-client/APICommands/SessionHandler";
import { IconButton } from "@/components/deprecated-mui/icon-button";
import { Tag } from "@/components/tag/tag";
import { NAMESPACES } from "@/i18n/constants";
import { DesktopAdminSettingsNavList, DesktopUserSettingsNavList } from "./nav-links";
import { ProvideFeedbackButton } from "./provide-feedback-modal/provide-feedback-button";

/**
 * Settings menu
 */
export function SettingsMenu({ navBarHeight }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [badgeStyles, setBadgeStyles] = React.useState({});

    const navigate = useNavigate();

    const { t } = useTranslation(NAMESPACES.FEATURES.NAVIGATION);

    const isAdmin = Boolean(SessionHandler.admin);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        const baseStylesPerHeight = {
            35: {
                top: 2,
                right: -7,
                fontSize: 6,
                borderRadius: "7px",
            },
            45: {
                top: 2,
                right: -8,
                fontSize: 6,
                borderRadius: "7px",
            },
            55: {
                top: 4,
                right: -12,
                fontSize: 9,
                marginTop: "2px",
                padding: "5px",
            },
        };

        setBadgeStyles(baseStylesPerHeight[navBarHeight]);
    }, [navBarHeight]);

    return (
        <>
            <IconButton
                badgeSx={{
                    top: badgeStyles.top,
                    right: badgeStyles.right,
                }}
                onClick={handleOpen}
                icon={<SettingsIcon />}
                title={t("settings-menu.settings")}
            />
            <Menu anchorEl={anchorEl} keepMounted style={{ zIndex: 1400 }} open={open} onClose={handleClose}>
                {DesktopUserSettingsNavList.map((navItem) => (
                    <MenuItem
                        key={`SettingsMenu_${navItem.url}`}
                        component={Link}
                        to={navItem.url}
                        target={navItem.external ? "_blank" : undefined}
                        rel={navItem.external ? "noopener noreferrer" : undefined}
                        onClick={handleClose}
                    >
                        {t(`nav-links.${navItem.translationKey}`) || navItem.name}
                        {navItem.tagVariant && <Tag wrapperSx={{ marginLeft: 2 }} tagVariant={navItem.tagVariant} />}
                    </MenuItem>
                ))}
                <ProvideFeedbackButton onClick={handleClose} />
                <MenuItem
                    key={"SettingsMenu_logout"}
                    onClick={() => {
                        const { search, hash } = window.location;
                        navigate(`/auth/logout${search}${hash}`);
                    }}
                >
                    {t("nav-bar.log-out")}
                </MenuItem>

                {isAdmin && (
                    <Box>
                        <Divider />
                        <Typography sx={{ paddingLeft: 2, paddingTop: 2 }} variant={"subtitle2"}>
                            Admin Settings
                        </Typography>
                        {DesktopAdminSettingsNavList.map((navItem) => (
                            <MenuItem
                                key={`SettingsMenu_${navItem.url}`}
                                component={Link}
                                to={navItem.url}
                                onClick={handleClose}
                            >
                                {navItem.name}
                            </MenuItem>
                        ))}
                    </Box>
                )}
            </Menu>
        </>
    );
}
